import { render, staticRenderFns } from "./ScrollableWidget.vue?vue&type=template&id=18d140a2&"
import script from "./ScrollableWidget.vue?vue&type=script&lang=js&"
export * from "./ScrollableWidget.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports